var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "vicon",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        fill: "currentColor",
        viewBox: "0 0 40 32",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M2 18L10 26L20 10",
          stroke: "currentColor",
          "stroke-width": "4",
          fill: "none",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { transform: "scale(0.04) translate(430,50)" } }, [
        _c("path", {
          staticStyle: {
            fill: "none",
            stroke: "#ff7302",
            "stroke-width": "40",
          },
          attrs: {
            d: "m 145,312 c -2,69 31,100 104,102 78,1 113,-34 109,-101 -6,-58 -62,-73 -106,-79 -48,-17 -99,-25 -99,-95 0,-48 32,-79 99,-78 60,0 97,25 96,84",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticStyle: { stroke: "#ff7302", "stroke-width": "30" },
          attrs: { d: "m 250,15 0,470" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }